import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DeviceMobile, X, DownloadSimple } from "@phosphor-icons/react";
import { useInstallPrompt, isAndroid } from "@/lib/install";

const KEY = "uu_android_install_dismissed";

/** Chrome on Android: offer the real install prompt once, then stay out of the way. */
export const InstallAndroid = () => {
  const { canInstall, installed, install } = useInstallPrompt();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    if (!isAndroid() || installed) return;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, [installed]);

  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };

  if (!show || installed) return null;

  return (
    <div
      data-testid="android-install-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] border-t border-white/10 bg-[#0F172A] px-4 pb-[max(env(safe-area-inset-bottom),0.75rem)] pt-3 text-white shadow-2xl lg:hidden"
    >
      <div className="mx-auto flex max-w-2xl items-start gap-3">
        <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center bg-[#2E7D32]">
          <DeviceMobile size={18} weight="bold" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Install Unity &amp; Utility</p>
          <p className="mt-0.5 text-xs leading-relaxed text-slate-300">
            {canInstall
              ? "One tap and it runs full screen on your home screen. No Play Store download."
              : "Use Chrome's ⋮ menu → Install app. It runs full screen, with nothing to download."}
          </p>
          <div className="mt-2 flex items-center gap-3">
            {canInstall && (
              <button
                type="button"
                data-testid="android-banner-install"
                onClick={async () => { await install(); dismiss(); }}
                className="bg-[#002FA7] px-3 py-2 text-xs font-semibold uppercase tracking-wider text-white"
              >
                <DownloadSimple size={13} className="mr-1 inline align-[-2px]" /> Install
              </button>
            )}
            <Link
              to="/android"
              data-testid="android-banner-learn-more"
              onClick={dismiss}
              className="tap-safe text-xs font-semibold text-[#7FA0FF]"
            >
              What works on the phone
            </Link>
          </div>
        </div>
        <button
          type="button"
          data-testid="android-banner-dismiss"
          aria-label="Dismiss"
          onClick={dismiss}
          className="flex h-10 w-10 shrink-0 items-center justify-center text-slate-400"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};
